import PropTypes from "prop-types";
import { Button } from "@mui/material";
import { useClient } from "../../context/ClientProvider";

function ActionButton({
  id,
  buttonColor,
  buttonTextColor,
  buttonTitle,
  variant = "contained",
  borderColor,
  hoverColor,
  hoverTextColor,
  hoverBorderColor,
  target = "/",
  disabled = false,
  onClick,
  sx = {},
}) {
  const { useGetConfig } = useClient();
  const { clientConfig } = useGetConfig();

  const handleClick = (event) => {
    if (onClick) return onClick(event);

    const isNavigable =
      target.startsWith("tel:") ||
      target.startsWith("http://") ||
      target.startsWith("https://") ||
      target.startsWith("/");

    if (isNavigable) {
      window.location.href = target;
    }
  };

  return (
    clientConfig && (
      <Button
        id={id}
        disabled={disabled}
        onClick={handleClick}
        variant={variant}
        sx={{
          textTransform: "none",
          borderRadius: clientConfig?.layout?.buttonBorderRadius,
          width: { xs: "15em", lg: "20em" },
          backgroundColor: variant === "outlined" ? "transparent" : buttonColor,
          color: buttonTextColor,
          border: borderColor ? `1px solid ${borderColor}` : undefined,
          borderStyle: borderColor ? "solid" : undefined,
          borderWidth: borderColor ? "1px" : undefined,
          borderColor: borderColor || undefined,
          boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
          "&:hover": {
            backgroundColor: hoverColor,
            color: hoverTextColor,
            borderStyle: hoverBorderColor || borderColor ? "solid" : undefined,
            borderWidth: hoverBorderColor || borderColor ? "1px" : undefined,
            borderColor: hoverBorderColor || borderColor,
          },
          ...sx
        }}

      >
        {buttonTitle}
      </Button>
    )
  );
}
ActionButton.propTypes = {
  id: PropTypes.string.isRequired,
  buttonColor: PropTypes.string,
  buttonTextColor: PropTypes.string,
  buttonTitle: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(["contained", "outlined", "text"]),
  borderColor: PropTypes.string,
  hoverColor: PropTypes.string,
  hoverTextColor: PropTypes.string,
  hoverBorderColor: PropTypes.string,
  target: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  sx: PropTypes.object,
};

export default ActionButton;
